import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M20.793 6.315a.7.7 0 0 1 .004.99L10.505 17.68a.7.7 0 0 1-.994 0l-6.308-6.359a.7.7 0 1 1 .994-.985l5.811 5.857 9.795-9.874a.7.7 0 0 1 .99-.004"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
